module.exports = __webpack_public_path__ + "28bdca00652c297f41c953ffac707527.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/puffy-jacket-pink.png
// module id = 1366
// module chunks = 0